import { getIssueKey } from '@atlassian/jira-router-resources-utils/src/utils/get-issue-key/index.tsx';
import { createResource } from '@atlassian/react-resource-router';
import getData from './get-data/index.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const issueViewRemoteDataResource = createResource<any>({
	type: 'ISSUE_VIEW_REMOTE_DATA',
	getKey: ({ match }) => {
		const issueKey = getIssueKey(match);
		return issueKey || '';
	},
	getData: (...args) => getData(...args),
	isBrowserOnly: true,
});
